// Message detail page (CHG-1262 / ITER-3387).
//
// Thin per v2-canary: configuration in @generated/screens. Future generator
// regenerates messageDetailConfig from message.entity-hint.yaml.
//
// Spec: specs/tier-05-experience/message-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { messageDetailConfig } from "../generated/screens/message-detail";

export function MessageDetail() {
  return <DetailPage config={messageDetailConfig} />;
}
